var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.st0 {\n  fill: #009bb5;\n}\n.st1 {\n  fill: #ffffff;\n}\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 200,
    height: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,132.5c-17.8,0-31.5-14.3-31.5-32.6c0-18.3,13.5-32.3,31.5-32.3c12.5,0,23.6,6.3,29.1,17.7l30.3-10.1 c-9.5-23.1-31.8-37.7-59.1-37.7c-37.5,0-65.6,26.6-65.6,62.1c0,35.5,28.3,62.9,65.1,62.9c27.8,0,50.8-15.2,59.9-39.2l-30.8-10.3 C127,125.1,115.6,132.5,102.7,132.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckr);
export default __webpack_public_path__ + "static/media/checkr.8480f237.svg";
export { ForwardRef as ReactComponent };